import React from "react";
export default function RespIm(props) {
  var x = 0;
  var screen = getWindowDimensions();
  if (screen.width > props.x + 50) {
    x = props.x;
  } else {
    x = screen.width - 10;
  }

  var y = Math.round((x * props.y0) / props.x0) + "px";

  return (
    <img width={x + "px"} heigth={y} src={props.src} alt="posturalmente" />
  );

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
}
